"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.854 13.283H1.573A1.574 1.574 0 0 1 0 11.711V4.075C0 3.328.608 2.72 1.355 2.72h13.281c.747 0 1.355.608 1.355 1.355v7.642h-.971V4.075a.384.384 0 0 0-.384-.383H1.355a.384.384 0 0 0-.383.383v7.636c0 .331.27.601.601.601H16l-.084.234a1.144 1.144 0 0 1-1.062.737Zm-4.707-5.516h4.106v-.971h-4.106v.971Zm4.106 2.128h-4.106v-.972h4.106v.972Zm-11.83 1.464a2.963 2.963 0 0 1 5.926 0H2.424Zm2.963-3.408a1.68 1.68 0 1 0 0-3.359 1.68 1.68 0 0 0 0 3.359Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M22.453 19.863H2.21a2.211 2.211 0 0 1-2.209-2.21V6.016a1.88 1.88 0 0 1 1.878-1.878h20.244A1.88 1.88 0 0 1 24 6.015v11.46h-1.106V6.016a.773.773 0 0 0-.772-.772H1.878a.773.773 0 0 0-.772.772v11.639c0 .608.495 1.103 1.103 1.103h21.725l-.038.105a1.555 1.555 0 0 1-1.443 1.001Zm-6.986-8.408h5.885v-1.106h-5.885v1.106Zm5.885 3.243h-5.885V13.59h5.885v1.107Zm-10.72-5.371a2.633 2.633 0 1 1-5.267 0 2.633 2.633 0 0 1 5.267 0ZM7.999 12.66a4.647 4.647 0 0 0-4.647 4.646h9.293a4.646 4.646 0 0 0-4.646-4.646Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M29.938 26.484H2.946A2.949 2.949 0 0 1 0 23.538V8.02a2.506 2.506 0 0 1 2.504-2.504h26.992A2.506 2.506 0 0 1 32 8.02V23.3h-1.475V8.02a1.03 1.03 0 0 0-1.029-1.03H2.504a1.03 1.03 0 0 0-1.029 1.03v15.518c0 .81.66 1.47 1.471 1.47h28.966l-.051.142a2.073 2.073 0 0 1-1.923 1.334Zm-9.315-11.211h7.846v-1.475h-7.846v1.475Zm7.846 4.324h-7.846v-1.475h7.846v1.475Zm-14.294-7.162a3.51 3.51 0 1 1-7.021 0 3.51 3.51 0 0 1 7.021 0Zm-3.51 4.445a6.196 6.196 0 0 0-6.195 6.195h12.39a6.195 6.195 0 0 0-6.195-6.195Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.265 38.077a2.413 2.413 0 0 1-2.41-2.41V12.208c0-.961.781-1.744 1.743-1.744h40.804c.961 0 1.743.783 1.743 1.744v22.913H48V12.208a3.602 3.602 0 0 0-3.598-3.598H3.598A3.602 3.602 0 0 0 0 12.208v23.459a4.27 4.27 0 0 0 4.265 4.265H45.07c1.25 0 2.285-.752 2.704-1.857l-43.509.002Zm26.91-15.092h11.487V21.13H31.176v1.855Zm11.487 6.535H31.176v-1.855h11.486v1.855ZM21.703 18.4a5.516 5.516 0 1 1-11.032 0 5.516 5.516 0 0 1 11.032 0Zm-5.516 6.983c-5.376 0-9.735 4.358-9.735 9.734h19.47c0-5.376-4.359-9.734-9.735-9.734Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.687 50.77a3.218 3.218 0 0 1-3.214-3.215V16.279a2.327 2.327 0 0 1 2.324-2.325h54.406a2.327 2.327 0 0 1 2.324 2.325v30.55H64v-30.55a4.803 4.803 0 0 0-4.797-4.798H4.797A4.803 4.803 0 0 0 0 16.276v31.279a5.694 5.694 0 0 0 5.687 5.687h54.406a3.808 3.808 0 0 0 3.606-2.477l-58.012.004Zm35.88-20.124h15.316v-2.473H41.568v2.473Zm15.316 8.714H41.568v-2.473h15.315v2.473ZM28.937 24.532a7.355 7.355 0 1 1-14.71 0 7.355 7.355 0 0 1 14.71 0Zm-7.354 9.311c-7.168 0-12.98 5.811-12.98 12.98h25.959c0-7.169-5.811-12.98-12.979-12.98Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconID = function IconID(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'ID' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "ID"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconID.sizes = [16, 24, 32, 48, 64];
IconID.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconID;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/ID.js
// module id = 1769
// module chunks = 0